// React and related imports
import React from 'react';

// Flowbite components
import { Label, Card } from 'flowbite-react';

// i18 Translation
import { TFunction } from 'i18next';

// Types and Interfaces
import { IMultiLanguageValue } from '../../common/interfaces/MultiLanguageValue.interface';

// Redux hooks and selectors
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';

// Custom Components
import { LanguageDropdown } from '../Shared/LanguageSelectionDropdown/LanguageDropdown';
import { IVersion } from '../../common/interfaces/Version.interface';
import { ILanguageOption } from '../../common/interfaces/LanguageOption.interface';
import { MultiLanguageField } from '../Shared/MultiLanguageInput';

interface MultiLangVersionTextAreaProps {
  t: TFunction<'translation', undefined>;
  version: IVersion;
  updateVersionField: (
    field: keyof IVersion,
    value: IMultiLanguageValue[]
  ) => void;
  selectedLanguage: ILanguageOption;
  setSelectedLanguage: (language: ILanguageOption) => void;
}

export const MultiLangVersionTextArea: React.FC<
  MultiLangVersionTextAreaProps
> = ({
  t,
  version,
  updateVersionField,
  selectedLanguage,
  setSelectedLanguage,
}) => {
  const isDarkMode = useAppSelector(selectIsDarkMode);

  return (
    <Card>
      <div className="mb-4">
        <Label
          value={t('versionsManagement.selectLanguage')}
          className="mb-2"
        />
        <LanguageDropdown
          selectedLanguage={selectedLanguage}
          onSelectLanguage={setSelectedLanguage}
          isDarkMode={isDarkMode}
        />
      </div>

      <MultiLanguageField
        config={{
          id: 'versionMessage-input',
          label: 'versionsManagement.message',
          type: 'textarea',
          placeholder: 'placeholders.versionMessage',
          required: true,
          autoFocus: true,
          rows: 5,
          className: 'mt-1',
        }}
        value={version?.message || []}
        onChange={(value) => updateVersionField('message', value)}
        selectedLanguage={selectedLanguage}
        showLanguageDropdown={false}
        t={t}
        wrapInCard={false}
      />
    </Card>
  );
};
